import { Component, Input } from '@angular/core';
import { Product } from '@shared/models/product.model';

@Component({
  selector: 'app-featured-collection',
  templateUrl: './featured-collection.component.html',
  styleUrls: ['./featured-collection.component.scss']
})
export class FeaturedCollectionComponent {
  @Input() products: Product[] = [];

  trackByProduct(_: number, p: Product): any {
    return p.productSkus?.[0]?.id ?? _;
  }
}
